import Vue from 'vue'
import './amplify'
import App from '@/App.vue'
import router from '@/router'
import vuetify from '@/plugins/vuetify'
import '@/plugins/vue-meta'
import { createProvider } from '@/vue-apollo'
import i18n from '@/i18n'
import BaseLayout from '@/layouts/Base.vue'
import ChecklistsLayout from '@/layouts/Checklists.vue'
import PagesLayout from '@/layouts/Pages.vue'
import ContentHeader from '@/components/ContentHeader.vue'
import AsyncComputedPlugin from 'vue-async-computed'
import VueQuillEditor from 'vue-quill-editor'

// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor)
Vue.use(AsyncComputedPlugin)

Vue.config.productionTip = false

Vue.component('base-layout', BaseLayout)
Vue.component('checklists-layout', ChecklistsLayout)
Vue.component('pages-layout', PagesLayout)

Vue.component('content-header', ContentHeader)

export const apolloProvider = createProvider()
export const apolloClient = apolloProvider.defaultClient

export const app = new Vue({
  router,
  vuetify,
  apolloProvider,
  i18n,
  render: h => h(App)
}).$mount('#app')
